import React, { useEffect, useState } from "react";

//styles
import "../include/css/bootstrap.min.css";
import "../include/css/style.css";
import "../include/css/dev.css";

//libs
import _ from "lodash";
import { Link, navigate } from "gatsby";

//component

import { Modal } from "react-bootstrap";
import { SEO } from "../components/seo";
import algoliasearch from "algoliasearch";
import Header from "../components/newDesign/header/header";

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);

const Category = ({ pageContext }) => {
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [filteredCategory, setFilteredCategory] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [catId, setCatId] = useState("");
  const [algoliaData, setAlgoliaData] = useState({});

  const initialData = async () => {
    let facets = ["*"];

    const records = await index.search("", {
      facets: facets,
      hitsPerPage: 0,
    });

    setAlgoliaData(records.facets);
  };

  useEffect(() => {
    initialData();
    // this.setState({ data: records?.facets });
  }, []);

  const filterCategory = (id) => {
    setCatId(id);
    const filteredCategory = pageContext.allManufacturers.find((es) => es.node.category_id == id);
    setFilteredCategory(filteredCategory);
  };

  const toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    setShowMobileFilter(!showMobileFilter);
  };
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  return (
    <>
      <Header/>
      <div class="cdm-upper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 extra-padding-bottom">
              <ul class="categories-nav-list d-flex flex-wrap">
                {pageContext.allManufacturers.length > 0 &&
                  pageContext.allManufacturers
                    ?.filter((sh) => sh?.node?.subManufacturers?.length > 0)
                    ?.map((ec, i) => (
                      <li class="cnl-item" key={i}>
                        <div class="cnl-box">
                          <h5>
                            <a
                              href={`/listings/index.cfm/catid/${ec.node.category_id}`}
                              onClick={(event) => {
                                event.preventDefault();
                                if (ec.node.description === "Pipe") {
                                  navigate(`/pipe`);
                                } else navigate(`/listings/index.cfm/catid/${ec.node.category_id}`);
                              }}
                            >
                              {ec.node.description}{" "}
                              {!_.isEmpty(algoliaData)
                                ? Object?.keys(algoliaData?.["categories.lvl0"]).some((key) =>
                                    key.toLowerCase().includes(ec.node.description.toLowerCase()),
                                  )
                                  ? `(${
                                      algoliaData?.["categories.lvl0"][
                                        `${Object.keys(algoliaData?.["categories.lvl0"]).find((key) =>
                                          key.toLowerCase().includes(ec.node.description.toLowerCase()),
                                        )}`
                                      ]
                                    })`
                                  : ""
                                : ""}
                            </a>
                          </h5>
                          <ul>
                            {ec.node.subManufacturers &&
                              ec.node.subManufacturers.length > 0 &&
                              ec.node.subManufacturers
                                ?.filter((sh) => sh?.description?.length > 0)
                                ?.sort((a, b) => a?.description?.localeCompare(b?.description))
                                ?.slice(0, 5)
                                ?.map((esc) => (
                                  <li>
                                    <a
                                      href={`/listings/index.cfm/catid/${ec.node.category_id}/mfr/${esc.mfrid}`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        navigate(`/listings/index.cfm/catid/${ec.node.category_id}/mfr/${esc.mfrid}`);
                                      }}
                                    >
                                      {esc.description}{" "}
                                      <span>
                                        {algoliaData?.["make"]?.[`${esc?.description}`]
                                          ? `(${algoliaData?.["make"]?.[`${esc?.description}`]})`
                                          : ""}
                                      </span>
                                    </a>
                                  </li>
                                ))}
                          </ul>
                          {ec.node.subManufacturers && ec.node.subManufacturers.length > 0 && (
                            <a
                              href="javascript:void(0)"
                              class="viewall_btn"
                              onClick={(event) => {
                                event.preventDefault();
                                filterCategory(ec.node.category_id);
                                toggleModal();
                              }}
                            >
                              View All
                            </a>
                          )}
                        </div>
                      </li>
                    ))}
                {pageContext.allManufacturers.length > 0 &&
                  pageContext.allManufacturers
                    ?.filter((sh) => sh?.node?.subManufacturers?.length === 0)
                    ?.map((ec, i) => (
                      <li class="cnl-item" key={i}>
                        <div class="cnl-box">
                          <h5>
                            <a
                              href={`/listings/index.cfm/catid/${ec.node.category_id}`}
                              onClick={(event) => {
                                event.preventDefault();
                                if (ec.node.description === "Pipe") {
                                  navigate(`/pipe`);
                                } else navigate(`/listings/index.cfm/catid/${ec.node.category_id}`);
                              }}
                            >
                              {ec.node.description}{" "}
                              {!_.isEmpty(algoliaData)
                                ? Object?.keys(algoliaData?.["categories.lvl0"]).some((key) =>
                                    key.toLowerCase().includes(ec.node.description.toLowerCase()),
                                  )
                                  ? `(${
                                      algoliaData?.["categories.lvl0"][
                                        `${Object.keys(algoliaData?.["categories.lvl0"]).find((key) =>
                                          key.toLowerCase().includes(ec.node.description.toLowerCase()),
                                        )}`
                                      ]
                                    })`
                                  : ""
                                : ""}
                            </a>
                          </h5>
                          <ul>
                            {ec.node.subManufacturers &&
                              ec.node.subManufacturers.length > 0 &&
                              ec.node.subManufacturers.slice(0, 5)?.map((esc) => (
                                <li>
                                  <a
                                    href={`/listings/index.cfm/catid/${ec.node.category_id}/mfr/${esc.mfrid}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate(`/listings/index.cfm/catid/${ec.node.category_id}/mfr/${esc.mfrid}`);
                                    }}
                                  >
                                    {esc.description}{" "}
                                    <span>
                                      {algoliaData?.["make"]?.[`${esc?.description}`]
                                        ? `(${algoliaData?.["make"]?.[`${esc?.description}`]})`
                                        : ""}
                                    </span>
                                  </a>
                                </li>
                              ))}
                          </ul>
                          {ec.node.subManufacturers && ec.node.subManufacturers.length > 0 && (
                            <a
                              href="javascript:void(0)"
                              class="viewall_btn"
                              onClick={(event) => {
                                event.preventDefault();
                                filterCategory(ec.node.category_id);
                                toggleModal();
                              }}
                            >
                              View All
                            </a>
                          )}
                        </div>
                      </li>
                    ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="cdm-lower cdm-lower-new w-100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 text-center">
              <Link to={"/all-manufacturers"} style={{ color: "#fff" }}>
                VIEW ALL MANUFACTURERS
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className={"modal fade salvex-modal"}
        dialogClassName="modal-dialog modal-lg modal-dialog-scrollable"
        show={showModal}
        onHide={toggleModal}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {filteredCategory && filteredCategory.node && `${filteredCategory.node.description}`}
            {!_.isEmpty(algoliaData)
              ? Object?.keys(algoliaData?.["categories.lvl0"]).some((key) =>
                  key.toLowerCase().includes(filteredCategory?.node?.description.toLowerCase()),
                )
                ? `(${
                    algoliaData?.["categories.lvl0"][
                      `${Object.keys(algoliaData?.["categories.lvl0"]).find((key) =>
                        key.toLowerCase().includes(filteredCategory?.node?.description.toLowerCase()),
                      )}`
                    ]
                  })`
                : ""
              : ""}
          </h5>
          <div className="searchInput">
            <input
              type="text"
              placeholder="Search"
              className="form-control"
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  const filteredCategory = pageContext.allManufacturers.find((es) => es.node.category_id == catId);
                  setFilteredCategory(filteredCategory);
                } else {
                  const filteredCategory = pageContext.allManufacturers.find((es) => es.node.category_id == catId);
                  const filteredSubManufacturers = filteredCategory.node.subManufacturers.filter((es) =>
                    es.description.toLowerCase().includes(value.toLowerCase()),
                  );
                  setFilteredCategory({
                    ...filteredCategory,
                    node: {
                      ...filteredCategory.node,
                      subManufacturers: filteredSubManufacturers,
                    },
                  });
                }
              }}
            />
          </div>
          <div className="close-btn" data-bs-dismiss="modal" onClick={toggleModal}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div className="modal-body">
          <ul className="three-column-row w-100">
            {filteredCategory &&
              filteredCategory.node &&
              filteredCategory.node.subManufacturers &&
              filteredCategory.node.subManufacturers.length > 0 &&
              filteredCategory.node.subManufacturers.map((v) => {
                return (
                  <li className="tcr-item">
                    <div className="form-check d-flex align-items-center p-0">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(`/listings/index.cfm/catid/${filteredCategory.node.category_id}/mfr/${v.mfrid}`);
                        }}
                        className="form-check-label"
                      >
                        {v.description}{" "}
                        {algoliaData?.["make"]?.[`${v?.description}`]
                          ? `(${algoliaData?.["make"]?.[`${v?.description}`]})`
                          : ""}
                      </a>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </Modal>
    </>
  );
};

export default Category;
export const Head = ({ location }) => (
  <SEO
    canonical={`https://www.salvex.com${location.pathname}`}
    title={`Manufacturer | Salvex`}
    description={`Browse listings by Manufacturer`}
  />
);
